<template>
  <div>
    <button style="display: none" @click="adClosed" id="ad-closed"></button>
    <button style="display: none" @click="adSuccess" id="ad-success"></button>
  </div>
</template>
<script>
export default {
  name: "Admob",
  props: {
    ad: {
      type: Boolean,
      default: false,
    },
  },
  data(){
      return {
          overlay: false
      }
  },
  computed: {
    agent() {
      return navigator.userAgent.toLowerCase();
    },
  },
  watch:{
      ad(ad){
          if(ad === true){
              this.showAd();
          }
      }
  },
  methods: {
    showAd() {
      if (this.agent.indexOf("wedone android") > -1) {
        window.android.showAd();
      } else if (this.agent.indexOf("ios") > -1) {
        webkit.messageHandlers.showAd.postMessage('');
      }
    },
    adSuccess() {
      this.$emit("succeed");
    },
    adClosed() {
      this.$emit("closed");
    },
  },
};
</script>